import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import ReactTooltip from "react-tooltip";
import { useTracking } from "react-tracking";
import { useTranslation } from "react-i18next";
import { catalogInstitutionClean, cleanSearchingCatalogInstitutionsPaginated } from "../../app/actions/catalogInstitutionActions";
import DisplayNameAndRole from "./DisplayNameAndRole";

const NavbarIconsCatalogInstitutions = ({ page }) => {
  const dispatch = useDispatch();
  const { trackEvent } = useTracking();
  const { t } = useTranslation();

    const { isUserAuthenticated } = useSelector((state) => state.auth);

  const [activeIcon, setActiveIcon] = useState(null);

  const handleActiveIcon = (icon) => {
    if (icon === "new") {
      trackEvent({ component: "NewCatalogInstitutions", event: "NewCatalogInstitutions-Clicked" });
    } else if (icon === "list") {
      trackEvent({ component: "ListCatalogInstitutions", event: "ListCatalogInstitutions-Clicked" });
      dispatch(cleanSearchingCatalogInstitutionsPaginated());
    }

    dispatch(catalogInstitutionClean());
    setActiveIcon(icon);
  };

  const iconActiveStyle = (icon) => {
    if (activeIcon === icon) {
      return "icon-d-flex active";
    } else {
      return "icon-d-flex";
    }
  };

  return (
    <div className="d-flex justify-content-between align-items-center flex-nowrap gradient-custom-sky custom-nav-height">
      {isUserAuthenticated && (
        <DisplayNameAndRole />
      )}
      {page === "listCatalogInstitutions" && (
        <Link
          data-tip
          data-for="newCatalogInstitutionsTip"
          to="/admin-institution/new-institution"
          className="p-2 bd-highlight"
          onClick={() => handleActiveIcon("new")}
        >
          <i className={`fa fa-plus-square fa-2x ${iconActiveStyle("new")}`} aria-hidden="true" />
        </Link>
      )}
      {page === "newCatalogInstitutions" && (
        <Link
          data-tip
          data-for="listCatalogInstitutionsTip"
          to="/admin-institution/"
          className="p-2 bd-highlight"
          onClick={() => handleActiveIcon("list")}
        >
          <i className={`fa fa-table fa-2x ${iconActiveStyle("list")}`} aria-hidden="true" />
        </Link>
      )}
      {page === "editCatalogInstitutions" && (
        <div className="navbar-module-actions">
          <Link
            data-tip
            data-for="listCatalogInstitutionsTip"
            to="/admin-institution/"
            className="p-2 bd-highlight"
            onClick={() => handleActiveIcon("list")}
          >
            <i className={`fa fa-table fa-2x ${iconActiveStyle("list")}`} aria-hidden="true" />
          </Link>
          <Link
            data-tip
            data-for="newCatalogInstitutionsTip"
            to="/admin-institution/new-institution"
            className="p-2 bd-highlight"
            onClick={() => handleActiveIcon("new")}
          >
            <i className={`fa fa-plus-square fa-2x ${iconActiveStyle("new")}`} aria-hidden="true" />
          </Link>
        </div>
      )}

      <ReactTooltip id="newCatalogInstitutionsTip" place="left" effect="solid">
        {t("admin-institution.page.register")}
      </ReactTooltip>
      <ReactTooltip id="listCatalogInstitutionsTip" place="left" effect="solid">
        {t("admin-institution.page.list")}
      </ReactTooltip>
    </div>
  );
};

export default NavbarIconsCatalogInstitutions;
